import { render, staticRenderFns } from "./face-shapes-choosing-a-style.vue?vue&type=template&id=a6346caa&scoped=true&"
import script from "./face-shapes-choosing-a-style.vue?vue&type=script&lang=js&"
export * from "./face-shapes-choosing-a-style.vue?vue&type=script&lang=js&"
import style0 from "./face-shapes-choosing-a-style.vue?vue&type=style&index=0&id=a6346caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6346caa",
  null
  
)

export default component.exports